import { useState } from "react";
import CustomersFilesWidget from "./CustomersFilesWidget";
import NetworkDiagramWidget from "../NetworkDiagram/NetworkDiagramWidget";
import CustomerGatewayWidget from "../NetworkGateway/CustomerGatewayWidget";
import ServiceCallWidget from "../ServiceCalls/ServiceCallsGridWidget";
import ServiceAgreementWidget from "../ServiceAgreements/ServiceAgreementGridWidget";
import WarrantyWidget from "../Warranties/WarrantyGridWidget";
import ServiceReportsWidget from "../ServiceReports/ServiceReportsGridWidget";
import SupportCasesWidget2 from "../SupportCases2/SupportCasesGridWidget";

import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
const CustomerTabStrip = (props: any) => {
  const [selected, setSelected] = useState(0);

  const handleSelect = (e: any) => {
    setSelected(e.selected);
  };
  return (

      <div className="tabstrip-container">
      <TabStrip
        selected={selected}
              onSelect={handleSelect}
              style={{ maxHeight: "100%" }}
              className="pp-tabstrip"
              keepTabsMounted={true}
      >
        <TabStripTab title="Customer Files">
          <CustomersFilesWidget id="101" header="Customer Files" />,
        </TabStripTab>
        <TabStripTab title="Network Diagram">
          <NetworkDiagramWidget
            id="200"
            header="Network Diagram"
            thumb={false}
          />
          ,
        </TabStripTab>
        <TabStripTab title="Remote Gateway">
          <CustomerGatewayWidget id="104" header="Remote Gateway Information" />
          ,
        </TabStripTab>
        <TabStripTab title="Service Calls">
          <ServiceCallWidget id="300" header="Service Calls" />
        </TabStripTab>
        {/*<TabStripTab title="Support Cases">*/}
        {/*  <SupportCasesWidget id="700" header="Support Cases" />*/}
        {/*      </TabStripTab>*/}
              <TabStripTab title="Support Cases">
                  <SupportCasesWidget2 id="701" header="Support Cases" />
              </TabStripTab>
              <TabStripTab title="Archive Service Reports">
          <ServiceReportsWidget id="500" header="Archive Service Reports" />
        </TabStripTab>
        <TabStripTab title="Service Agreements">
          <ServiceAgreementWidget id="400" header="Service Agreements" />,
        </TabStripTab>
        <TabStripTab title="Warranties">
          <WarrantyWidget id="600" header="Warranties" />,
        </TabStripTab>
      </TabStrip>
    </div>
  );
};
export default CustomerTabStrip;